import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AboutPage = () => {
    const { t } = useTranslation();

    const teamMembers = [
        {
            name: "Daniel Busch",
            role: t("about.team.daniel.role"),
            description: t("about.team.daniel.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/danielbusch.jpeg",
        },
        {
            name: "Moritz Busch",
            role: t("about.team.moritz.role"),
            description: t("about.team.moritz.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/moritzbusch.jpeg",
        },
        {
            name: "Dr. Oliver Busch",
            role: t("about.team.oliver.role"),
            description: t("about.team.oliver.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/oliverbusch.jpeg",
        },
    ];

    return (
        <div className="bg-white min-h-screen">
            <div className="max-w-6xl mx-auto px-4 py-16">
                {/* Hero Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-bold mb-6">{t("about.hero.title")}</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        {t("about.hero.subtitle")}
                    </p>
                </div>

                {/* Team Section */}
                <div className="mb-16">
                    <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
                        {t("about.team.title")}
                    </h2>
                    <p className="text-center text-gray-600 mb-12">{t("about.team.subtitle")}</p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center">
                                <div className="mb-6">
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-primary shadow-md"
                                    />
                                </div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                                    {member.name}
                                </h3>
                                <p className="text-primary font-semibold mb-4">{member.role}</p>
                                <p className="text-gray-700 leading-relaxed">
                                    {member.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mission Section */}
                <div className="border-primary border rounded-2xl p-12 text-center mb-16">
                    <h2 className="text-3xl font-bold mb-4 text-gray-900">
                        {t("about.mission.title")}
                    </h2>
                    <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
                        {t("about.mission.description")}
                    </p>
                </div>

                {/* CTA Section */}
                <div className="text-center">
                    <p className="text-gray-600 mb-4">{t("about.cta.text")}</p>
                    <a
                        href="mailto:kontakt@aussprachetrainer.org"
                        className="inline-block bg-primary hover:bg-purple-600 text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-300"
                    >
                        {t("about.cta.button")}
                    </a>
                </div>

                {/* Back to Legal Link */}
                <div className="mt-12 text-center">
                    <Link
                        to="/legal"
                        className="text-gray-600 hover:text-primary transition-colors duration-300"
                    >
                        ← {t("about.backToLegal")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
